import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WeeblyService } from '../../integrations/weebly/shared/weebly.service';
import { UserService } from '../../users/shared/user.service';
import { PlatformService } from '../../shared/platform/platform.service';

/**
 * content management links
 */
@Component({
  selector: 'wl-content-management-link',
  templateUrl: 'content-management-link.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class ContentManagementLink implements OnInit {
  public settingBatches: Array<string>;

  public constructor(
    private _router: Router,
    private _plateformService: PlatformService,
    private _userService: UserService,
    private _weeblyService: WeeblyService
  ) {
    this.settingBatches = new Array<string>();
  }

  public ngOnInit(): void {
    // make sure they should be here
    this._userService.getCurrentUserSecurityElementAccessLevel('Send_Mass_Communicatons').then((userAccessLevel: number) => {
      if (userAccessLevel < 1) {
        this._router.navigate(['access/denied']);
        return;
      }
    });
    this._weeblyService.getWeeblySettingBatches().then(data => {
      this.settingBatches = data;
      if (this.settingBatches.length == 1) {
        this.weeblyLogin(this.settingBatches[0]);
      }
    });
  }

  public weeblyLogin(settingBatch: string): void {
    this._weeblyService
      .getWeeblyLoginLink(settingBatch)
      .then(data => {
        this._plateformService.openPlatformWindow(data);
      })
      .catch();
  }
}
